import axios from "axios";

export default {

    methods: {
        orderChange(baseName){
            let self = this;
            self.sortLoadOrder(self.options);
            self.options = self.dataReorder;
            axios.post(route('api.settings.codes.update-state'), { stepsArray: self.dataReorder,name: baseName })
                .then(response => {
                    self.dataReorder = [];
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                });
        },

        getOptionsArray(data){
            let self = this;
            self.sortLoadOrder(data);
            self.options = self.dataReorder;
            self.dataReorder = [];
        },

        sortLoadOrder(data){
            let self = this;
            data.forEach((item, index) => {
                let object = {
                    "id": item.id,
                    "code": item.code,
                    "full_description": item.full_description,
                    "short_description": item.short_description,
                    "load_order": index+1,
                    "is_competitor": item.is_competitor,
                    "competitor_status": item.competitor_status ? true: false,
                    "created_at": item.created_at,
                    "deleted_at": item.deleted_at,
                    "legacy_id": item.legacy_id,
                    "locked": item.locked,
                    "updated_at": item.updated_at,
                    "team_id": item.team_id,
                    "color": item.color ?? null,
                    "comment": item.comment ?? null,
                    "contract": item.contract ?? null,
                    "dead": item.dead ?? null,
                    "phase": item.phase ?? null,
                    "pipeline": item.pipeline ?? null,
                    "probability_percentage": item.probability_percentage  ?? null,
                    "sync_ryvit_at": item.sync_ryvit_at ?? null,
                    "add_to_won_contract": item.add_to_won_contract ?? null,
                }
                Vue.set(self.dataReorder, index, object);
            });
        }
    },
};
